<template lang="html">
  <div class="content">
    <div class="announce">
      <div class="title">{{title}}</div>
      <div class="content" v-html="content"></div>
    </div>
  </div>
</template>

<script>
import common from '@common/common'
import {apis} from '@common/config'

export default {
  name: 'announcement',
  data() {
    return {
      title: '暂无标题',
      content: '暂无内容'
    }
  },
  methods: {
    getData() {
      const id = this.$route.query.d || ''
      const info = {
        id: id
      }

      common.myFetch(apis.announcement, info)
      .then(r => {
        if (r) {
          this.title = r.title || this.title
          this.content = r.content || this.content
        }
      })
    }
  },
  mounted() {
    this.getData()
  }
}
</script>

<style lang="less" scoped>
  @import '../assets/css/global.less';

  .announce {
    padding: 20px 30px;
    .boxOuter;
    min-height: 100%;
    color: @dark;
    .title {
      font-size: 24px;
      margin-bottom: 20px;
    }
    .content {
      line-height: 30px;
      text-align: justify;
      word-break: break-all;
      max-width: 100%;
    }
  }
</style>
